import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TokenService } from '../service/token.service';
import { ChannelMappingInfo } from '../model/ChannelMapping.model';
import { DealerTypeInfo } from '../model/DealerTypeInfo.model';
import { BusinessSectorInfo } from '../model/BusinessSectorInfo.model';
import { AssetCategoryInfoInfo } from '../model/AssetCategoryInfoInfo.model';
import { AssetTypeInfo } from '../model/AssetTypeInfo.model';
import { TeamInfo } from '../model/team.model';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { DealerInfo } from '../model/DealerInfo.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe, Location } from '@angular/common';

@Component({
  selector: 'app-dealer-mapping',
  templateUrl: './dealer-mapping.component.html',
  styleUrls: ['./dealer-mapping.component.css']
})
export class DealerMappingComponent implements OnInit {
  ChannelMappingList: ChannelMappingInfo[] = [];
  ChannelTypeCode: string = '';
  ChannelTypeName: string = '';
  ChannelTypeFlagDealer: string = '';
  loading: boolean = false;
  environment: number = 10;
  currentPageNumber: number = 1;
  totalPages: number = 1;
  totalItems: number = 0;
  baseurl: string = '';
  canEdit: boolean = true;
  updatedMappings: ChannelMappingInfo[] = [];
  form: FormGroup;
  isOnUpdate: boolean = false;

  // Dealer Master Section
  DealerTypeList: DealerTypeInfo[] = [];
  BusinessSectorList: BusinessSectorInfo[] = [];
  AssetCategoryList: AssetCategoryInfoInfo[] = [];
  AssetTypeList: AssetTypeInfo[] = [];
  SaleTeamList: TeamInfo[] = [];
  SaleStaffList: SaleTeamMappingEmployeeInfo[] = [];
  DealerList: DealerInfo[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private TokenService: TokenService,
    private formBuilder: FormBuilder,
    private location: Location,
    private datePipe: DatePipe
  ) {
    this.baseurl = environment.base_api;
  }

  async ngOnInit(): Promise<void> {
    this.form = this.formBuilder.group({
      ChannelMappingId: [0],
      ChannelMappingCode: [null],
      ChannelMappingName: [null, Validators.required],
      ChannelMappingPhone: [null],
      ChannelMappingEmail: [null],
      ChannelMappingFlagActive: ['Y'],
      ChannelTypeCode: [null],
      ChannelTypeName: [null],
      ChannelTypeFlagDealer: [null],
      ChannelMappingCreateBy: [null],
      ChannelMappingUpdateBy: [null],
      DealerId: [0],
      DealerCode: [null],
      DealerName: [null],
      DealerType: [null, Validators.required],
      DealerCompanyProfile: [null],
      DealerBusinessSector: [null, Validators.required],
      DealerWebSite: [null],
      DealerContactName: [null],
      DealerContactPhone: [null],
      DealerContactEmail: [null],
      DealerFirstDealDate: [null, Validators.required],
      AssetCategoryCode: [null, Validators.required],
      AssetTypeCode: [null, Validators.required],
      TeamCode: [null, Validators.required],
      EmployeeCode: [null, Validators.required]
    });

    // Get state from navigation
    const state = history.state;

    // Check if state is undefined or doesn't contain required properties
    if (!state || !state.ChannelTypeId || !state.ChannelTypeCode) {
      console.log('Invalid channel type parameters received, redirecting back...');
      this.router.navigate(['/channel-type-management']);
      return;
    }

    await this.LoadDealerTypeList();
    await this.LoadBusinessSectorList();
    await this.LoadAssetCategoryList();
    await this.LoadSaleTeamList();

    this.ChannelTypeCode = state.ChannelTypeCode;
    this.ChannelTypeName = state.ChannelTypeName;
    this.ChannelTypeFlagDealer = state.ChannelTypeFlagDealer;

    // Load channel mapping data
    this.getChannelMappingList();
  }

  async getChannelMappingList() {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        ChannelTypeCode: this.ChannelTypeCode,
        ChannelMappingType: "D",
        rowFetch: this.environment,
        rowOFFSet: ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * this.environment
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "Channel/GetChannelMappingList",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ChannelMappingList = response;
      this.totalItems = this.ChannelMappingList.length;

      if (this.ChannelMappingList.length <= 0) {
        this.currentPageNumber = 0;
      } else {
        if (this.currentPageNumber == 0) this.currentPageNumber = 1;
        this.totalItems = Number(this.ChannelMappingList[0].itemTotal);
      }

      this.totalPages = Math.ceil(this.totalItems / this.environment);
    } catch (error) {
      console.error('Error loading dealer mapping:', error);
      alert('An error occurred while loading dealer mapping data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  LoadChannelMappingList(event: any) {
    //this.currentPageNumber = event.currentPageNumber;
    //this.environment = event.environment;
    if (event != null) {
      this.currentPageNumber = event.currentPageNumber;
      this.totalPages = event.totalPages;
    }
    this.getChannelMappingList();
  }

  onCheckboxChange(item: ChannelMappingInfo, event: any) {
    // Store the updated mapping
    const updatedItem = {
      ...item,
      ChannelMappingFlagActive: event.target.checked ? 'Y' : 'N'
    };

    // Check if already exists in updatedMappings
    const existingIndex = this.updatedMappings.findIndex(x => x.ChannelMappingId === item.ChannelMappingId);
    if (existingIndex >= 0) {
      this.updatedMappings[existingIndex] = updatedItem;
    } else {
      this.updatedMappings.push(updatedItem);
    }
  }

  async btnClick_submitMapping() {
    if (this.updatedMappings.length === 0) {
      alert('No changes to submit');
      return;
    }

    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // Update each mapping
      for (const mapping of this.updatedMappings) {
        const response = await this.httpClient.put<any>(
          this.baseurl + `Channel/UpdateChannelMapping`,
          JSON.stringify(mapping),
          httpOptions
        ).toPromise();

        if (!response || !response.success) {
          throw new Error('Failed to update mapping');
        }
      }

      alert('Channel mappings updated successfully');
      // Clear updated mappings and refresh list
      this.updatedMappings = [];
      await this.getChannelMappingList();
    } catch (error) {
      console.error('Error submitting mappings:', error);
      alert('An error occurred while submitting mappings. Please try again.');
    }
  }

  async btnSave() {
    if (this.form.invalid) {
      this.validateAllFormFields(this.form);
      return;
    }

    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    try {
      const formData = this.form.value;
      
      // Set CreateBy and UpdateBy based on operation type
      if (this.isOnUpdate) {
        formData.ChannelMappingUpdateBy = localStorage.getItem("EmpCode");
      } else {
        formData.channelMappingId = 0;
        formData.ChannelMappingCreateBy = localStorage.getItem("EmpCode");
        formData.ChannelTypeCode = this.ChannelTypeCode;
        formData.ChannelMappingType = "D";
      }

      console.log('formData', formData);

      const channelMappingId = await this.httpClient.post<number>(
        this.baseurl + "Channel/SaveChannelMapping",
        JSON.stringify(formData),
        httpOptions
      ).toPromise();

      if (channelMappingId > 0) {
        this.form.patchValue({
          ChannelMappingId:   channelMappingId,
          DealerCode: this.form.get('ChannelMappingCode').value,
          DealerName: this.form.get('ChannelMappingName').value
        });

        const okDealer = await this.SaveDealer();
        if (!okDealer) {
          alert('Failed to save dealer');
          return;
        }


        this.Clearinput();
        await this.getChannelMappingList();
        $('#ModalChannelMapping').modal('hide');
        
        // Show success message
        const message = this.isOnUpdate ? 'Dealer mapping updated successfully' : 'Dealer mapping created successfully';
        alert(message);
      } else {
        // Handle unsuccessful response
        console.error('Save failed');
        alert('Failed to save dealer mapping');
      }
    } catch (error) {
      console.error('Error saving dealer mapping:', error);
      alert('An error occurred while saving dealer mapping. Please try again.');
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      } else {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  Clearinput() {
    this.form.reset();
    this.form.patchValue({
      ChannelMappingId: 0,
      ChannelMappingFlagActive: 'Y'
      // ChannelMappingCode: null,
      // ChannelMappingName: null,
      // ChannelMappingPhone: null,
      // ChannelMappingEmail: null,
      // ChannelTypeCode: this.ChannelTypeCode,
      // ChannelTypeName: this.ChannelTypeName,
      // ChannelTypeFlagDealer: this.ChannelTypeFlagDealer
    });
  }

  async btnClick_onCreateChannelMapping() {
    this.isOnUpdate = false;
    this.Clearinput();
    $('#ModalChannelMapping').modal('show');
  }

  async btnClick_onUpdateChannelMapping(channelMappingId: number) {
    try {
      this.form.reset();
      const channelMapping = this.ChannelMappingList.find(x => x.ChannelMappingId === channelMappingId);
      if (channelMapping) {
        this.isOnUpdate = true;
        
        this.form.patchValue({
          ChannelMappingId: channelMapping.ChannelMappingId,
          ChannelMappingCode: channelMapping.ChannelMappingCode,
          ChannelMappingName: channelMapping.ChannelMappingName,
          ChannelMappingPhone: channelMapping.ChannelMappingPhone,
          ChannelMappingEmail: channelMapping.ChannelMappingEmail,
          ChannelMappingFlagActive: channelMapping.ChannelMappingFlagActive,
          ChannelTypeCode: this.ChannelTypeCode,
          ChannelTypeName: this.ChannelTypeName,
          ChannelTypeFlagDealer: this.ChannelTypeFlagDealer
        });

        const dealerDataList = await this.LoadDealerList(channelMappingId);

        if (dealerDataList && dealerDataList.length > 0) {
        const dealerData = dealerDataList[0]; 

        this.form.patchValue({
          AssetCategoryCode: dealerData.AssetCategoryCode,
          TeamCode: dealerData.TeamCode,
        });

        await Promise.all([
          this.LoadAssetTypeList(dealerData.AssetCategoryCode),
          this.LoadSaleStaffList(dealerData.TeamCode)
        ]);
        
        let formattedFirstDealDate: string | null = null;
          if (dealerData.DealerFirstDealDate) {
              // Date object from ISO 8601 string
              const dateObject = new Date(dealerData.DealerFirstDealDate);
              if (!isNaN(dateObject.getTime())) {
                  formattedFirstDealDate = this.datePipe.transform(dateObject, 'yyyy-MM-dd');
              }
          }

        setTimeout(() => {
        // Patch Dealer data into the form
        this.form.patchValue({
          DealerId: dealerData.DealerId,
          // DealerCode: dealerData.DealerCode, // No Update anymore
          DealerName: dealerData.DealerName,
          DealerType: dealerData.DealerType,
          DealerCompanyProfile: dealerData.DealerCompanyProfile,
          DealerBusinessSector: dealerData.DealerBusinessSector,
          DealerWebSite: dealerData.DealerWebSite,
          DealerContactName: dealerData.DealerContactName,
          DealerContactPhone: dealerData.DealerContactPhone,
          DealerContactEmail: dealerData.DealerContactEmail,
          //DealerFirstDealDate: dealerData.DealerFirstDealDate, //formattedFirstDealDate
          DealerFirstDealDate: formattedFirstDealDate,
          //AssetCategoryCode: dealerData.AssetCategoryCode,
          AssetTypeCode: dealerData.AssetTypeCode,
          //TeamCode: dealerData.TeamCode,
          EmployeeCode: dealerData.EmployeeCode
        });
        }, 100);

      } else {
        console.warn(`No dealer data found or an error occurred for ChannelMappingId: ${channelMappingId}. Or the returned list is empty.`);
      }

        $('#ModalChannelMapping').modal('show');
      }
    } catch (error) {
      console.error('Error updating dealer mapping:', error);
      alert('An error occurred while updating dealer mapping. Please try again.');
    }
  }

  async btnClick_deleteChannelMapping(channelMappingId: number) {
    if (!confirm('Are you sure you want to delete this dealer mapping?')) {
      return;
    }

    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const response = await this.httpClient.delete<any>(
        this.baseurl + `Channel/DeleteChannelMapping/${channelMappingId}`,
        httpOptions
      ).toPromise();

      if (response && response.success) {
        alert('Dealer mapping deleted successfully');
        await this.getChannelMappingList();
      } else {
        alert('Failed to delete dealer mapping');
      }
    } catch (error) {
      console.error('Error deleting dealer mapping:', error);
      alert('An error occurred while deleting dealer mapping. Please try again.');
    }
  }

  async LoadDealerTypeList() {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
          const httpOptions = {
              headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${auth_token}`
              })
          };
  
          var objectjson = {};
          let strjson = JSON.stringify(objectjson);
  
          try {
              const data = await this.httpClient.post<DealerTypeInfo[]>(this.baseurl + "DealerType/GetDealerType", strjson, httpOptions).toPromise();
              
              this.DealerTypeList = data;
              //console.log('loadDealerTypeList: ', this.DealerTypeList);

              if (this.DealerTypeList.length > 0) {
                //this.form.get('DealerType')!.setValue(this.DealerTypeList[0].DealerTypeCode);
              }
  
          } catch (error) {
              console.error('LoadDealerTypeList: Error', error);
              this.DealerTypeList = [];
          }
      } else {
          console.error('LoadDealerTypeList: Token ไม่พร้อมใช้งาน');
          this.DealerTypeList = [];
      }
  }

  async LoadBusinessSectorList() {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
          const httpOptions = {
              headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${auth_token}`
              })
          };
  
          var objectjson = {};
          let strjson = JSON.stringify(objectjson);
  
          try {
              const data = await this.httpClient.post<BusinessSectorInfo[]>(this.baseurl + "BusinessSector/GetBusinessSector", strjson, httpOptions).toPromise();
              
              this.BusinessSectorList = data;
              //console.log('BusinessSectorList: ', this.BusinessSectorList);

              if (this.BusinessSectorList.length > 0) {
                //this.form.get('DealerBusinessSector')!.setValue(this.BusinessSectorList[0].BusinessSectorCode);
              }
  
          } catch (error) {
              console.error('LoadBusinessSectorList: Error', error);
              this.BusinessSectorList = [];
          }
      } else {
          console.error('LoadBusinessSectorList: Token ไม่พร้อมใช้งาน');
          this.BusinessSectorList = [];
      }
  }

  async LoadAssetCategoryList() {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
          const httpOptions = {
              headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${auth_token}`
              })
          };
  
          var objectjson = {};
          let strjson = JSON.stringify(objectjson);
  
          try {
              const data = await this.httpClient.post<AssetCategoryInfoInfo[]>(this.baseurl + "AssetType/GetAssetCategory", strjson, httpOptions).toPromise();
              
              this.AssetCategoryList = data;
              //console.log('AssetCategoryList: ', this.AssetCategoryList);
  
          } catch (error) {
              console.error('LoadAssetCategoryList: Error', error);
              this.AssetCategoryList = [];
          }
      } else {
          console.error('LoadAssetCategoryList: Token ไม่พร้อมใช้งาน');
          this.AssetCategoryList = [];
      }
  }

  async onAssetCategoryChange(selectedCode: string | null): Promise<void> {
    //console.log('Selected Asset Category:', selectedCode);
    await this.LoadAssetTypeList(selectedCode);
  }

  async LoadAssetTypeList(categorycode: string) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
          const httpOptions = {
              headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${auth_token}`
              })
          };
  
          var objectjson = {
            AssetCategoryCode: this.checkUndefinedString(categorycode)
          };
          let strjson = JSON.stringify(objectjson);
  
          try {
              const data = await this.httpClient.post<AssetTypeInfo[]>(this.baseurl + "AssetType/GetAssetType", strjson, httpOptions).toPromise();
              
              this.AssetTypeList = data;
              console.log('AssetTypeList: ', this.AssetTypeList);
  
          } catch (error) {
              console.error('LoadAssetTypeList: Error', error);
              this.AssetTypeList = [];
          }
      } else {
          console.error('LoadAssetTypeList: Token ไม่พร้อมใช้งาน');
          this.AssetTypeList = [];
      }
  }

  async LoadSaleTeamList() {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
          const httpOptions = {
              headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${auth_token}`
              })
          };
  
          var objectjson = {};
          let strjson = JSON.stringify(objectjson);
  
          try {
              const data = await this.httpClient.post<TeamInfo[]>(this.baseurl + "Team/GetTeamCriteria", strjson, httpOptions).toPromise();
              
              this.SaleTeamList = data;
              console.log('SaleTeamList: ', this.SaleTeamList);
  
          } catch (error) {
              console.error('LoadSaleTeamList: Error', error);
              this.SaleTeamList = [];
          }
      } else {
          console.error('LoadSaleTeamList: Token ไม่พร้อมใช้งาน');
          this.SaleTeamList = [];
      }
  }

  async onSaleTeamChange(selectedCode: string | null): Promise<void> {
    //console.log('Selected TeamCode:', selectedCode);
    await this.LoadSaleStaffList(selectedCode)
  }

  async LoadSaleStaffList(teamCode: string) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
          const httpOptions = {
              headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${auth_token}`
              })
          };
  
          var objectjson = {
            SaleTeamCode: this.checkUndefinedString(teamCode)
          };
          let strjson = JSON.stringify(objectjson);
  
          try {
              const data = await this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeamRequest", strjson, httpOptions).toPromise();
              
              this.SaleStaffList = data;
              console.log('SaleStaffList: ', this.SaleStaffList);
  
          } catch (error) {
              console.error('LoadSaleStaffList: Error', error);
              this.SaleStaffList = [];
          }
      } else {
          console.error('LoadSaleStaffList: Token ไม่พร้อมใช้งาน');
          this.SaleStaffList = [];
      }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  async SaveDealer(): Promise<boolean> {
    // No check form no more because it check from btnSave
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    try {
      const formData = this.form.value;
      
      // Set CreateBy and UpdateBy based on operation type
      if (this.isOnUpdate) {
        formData.DealerUpdateBy = localStorage.getItem("EmpCode");
      } else {
        formData.DealerId = 0;
        formData.DealerCreateBy = localStorage.getItem("EmpCode");
      }

      console.log('formData', formData);

      const success = await this.httpClient.post<boolean>(
        this.baseurl + "Dealer/SaveDealer",
        JSON.stringify(formData),
        httpOptions
      ).toPromise();

        return success === true;
    } catch (error) {
      console.error('Error saving dealer mapping:', error);
      alert('An error occurred while saving dealer mapping. Please try again.');
    }
  }

  async LoadDealerList(channelMappingId: number): Promise<DealerInfo[]> | null {
    var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
          const httpOptions = {
              headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${auth_token}`
              })
          };
  
          var objectjson = {
            ChannelMappingId: channelMappingId
          };
          let strjson = JSON.stringify(objectjson);
  
          try {
              const data = await this.httpClient.post<DealerInfo[]>(this.baseurl + "Dealer/GetDealer", strjson, httpOptions).toPromise();
              
              this.DealerList = data;
              console.log('DealerList: ', this.DealerList);
  
              return data;
          } catch (error) {
              console.error('LoadDealerList: Error', error);
              this.DealerList = [];
          }
      } else {
          console.error('LoadDealerList: Token ไม่พร้อมใช้งาน');
          this.DealerList = [];
      }
  }

  GoBack() {
    this.location.back()
  }
}
